module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-section', {
    attrs: {
      "title": "Executive Dashboard",
      "set-position": "relative",
      "set-width": "100"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content ie p-executive-dashboard",
    attrs: {
      "id": "app"
    }
  }, [_c('icons'), _vm._v(" "), _c('page-header'), _vm._v(" "), _c('page-form'), _vm._v(" "), _c('div', {
    staticClass: "u-margin-bottom-40"
  }, [_c('reserve-section')], 1), _vm._v(" "), _c('div', {
    staticClass: "u-margin-bottom-40"
  }, [_c('numbers-section')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2271fc7e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/executive-dashboard/ExecutiveDashboard.vue
// module id = 1610
// module chunks = 0